import axios from "axios";
import { StatisticsURL } from "../../Services";
import { authenticatedHeader } from "../../DefaultConfig";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function getKeywordSource(keyword: string) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/source",
    {
      keyword: keyword,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getHotKeywordLastXHours(x: number) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL + "api/keyword/view/last-x-hours/" + String(x),
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getKeywordTrendLastXDays(keyword: string, x: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/appearances",
    {
      keyword: keyword,
      x: x,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getRelatedKeywords(keyword: string, x: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/related-keywords",
    {
      keyword: keyword,
      x: x,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getRelatedAdjectives(keyword: string, x: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/related-adjectives",
    {
      keyword: keyword,
      x: x,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getRelatedTopics(keyword: string, x: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/related-topics",
    {
      keyword: keyword,
      x: x,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getTopKeywordsListByTopicsLastXDays(
  topic: string,
  days: number
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/topics/days",
    {
      topic: topic,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getMostNegativeKeywordsByTopics(
  topic: string,
  days: number
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/sentiment/negative",
    {
      topic: topic,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getMostPositiveKeywordsByTopics(
  topic: string,
  days: number
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/sentiment/positive",
    {
      topic: topic,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getKeywordDetail(keyword: string, days: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/detail",
    {
      keyword: keyword,
      x: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
